import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input',
  styles: [require('./app-input.component.scss')],
  template: require('./app-input.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
})
export class AppInputComponent {
  @Input() control: FormControl;
  @Input() group: FormGroup;
  
  @Input() placeholder: string = '';
  @Input() id: string = '';
  @Input() label: string;
  @Input() labelIsHidden: boolean = false;
  @Input() type: 'text' | 'email' | 'password' = 'text';
  @Input() autocomplete: boolean = true;
  
  get autoCompleteStatus(): string {
    return this.autocomplete ? 'on' : 'off';
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/app-input/app-input.component.ts